import React from "react";

const SkillImg = ({ theme }) => {
	return (
		<svg
			id="a2942aa7-bf0d-42c0-bc52-bf4c952347c5"
			data-name="Layer 1"
			xmlns="http://www.w3.org/2000/svg"
			width="650"
			height="645.18443"
			viewBox="0 0 925.497 645.18443"
		>
			<title>Skills</title>
			<circle cx="233.08818" cy="328.45705" r="18.40881" fill="#f2f2f2" />
			<circle cx="170.08818" cy="540.45705" r="11.40881" fill="#f2f2f2" />
			<rect x="379.997" y="21.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="417.997" y="3.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="478.997" y="3.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="605.997" y="505.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="643.997" y="487.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="704.997" y="487.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="612.997" y="200.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="650.997" y="182.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="711.997" y="182.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="612.997" y="128.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="650.997" y="110.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="711.997" y="110.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="305.997" y="138.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="343.997" y="120.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="404.997" y="120.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="203.997" y="91.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="241.997" y="73.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="302.997" y="73.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="140.997" y="276.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="178.997" y="258.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="239.997" y="258.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="70.997" y="480.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="108.997" y="462.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="169.997" y="462.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="732.997" y="396.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="770.997" y="378.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="831.997" y="378.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="691.997" y="268.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="791.997" y="270" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="730.997" y="270" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="13.997" y="118.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="113.997" y="120" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="52.997" y="120" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="22.997" y="380.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="122.997" y="382" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="61.997" y="382" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="463.997" y="53.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="563.997" y="55" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="502.997" y="55" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="70.997" y="192.5" width="140" height="2" fill="#f2f2f2" />
			<rect x="108.997" y="174.5" width="2" height="18.5" fill="#f2f2f2" />
			<rect x="169.997" y="174.5" width="2" height="18.5" fill="#f2f2f2" />
			<path
				d="M370.7485,300.40779v471h436v-471Zm218,34a15,15,0,1,1,15-15A15,15,0,0,1,588.7485,334.40779Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.text}
			/>
			<path
				d="M174.50646,731.20512c6.914,25.55824,30.59593,41.38709,30.59593,41.38709s12.47217-25.60922,5.55819-51.16745-30.59593-41.38709-30.59593-41.38709S167.59248,705.64689,174.50646,731.20512Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.text}
			/>
			<path
				d="M184.66607,725.71239c18.97207,18.46854,21.28937,46.859,21.28937,46.859s-28.4425-1.553-47.41457-20.02152-21.28937-46.859-21.28937-46.859S165.694,707.24384,184.66607,725.71239Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.imageHighlight}
			/>
			<rect x="16.497" y="643" width="909" height="2" fill="#3f3d56" />
			<path
				d="M329.2485,708.74592a22.03138,22.03138,0,0,0-14.03113-20.5,22,22,0,1,0-15.93774,0,21.99119,21.99119,0,0,0,0,41,22,22,0,1,0,15.93774,0A22.03137,22.03137,0,0,0,329.2485,708.74592Zm-42-41a20,20,0,1,1,24.51294,19.46735,22.02316,22.02316,0,0,0-9.02588,0A20.02094,20.02094,0,0,1,287.2485,667.74592Zm40,82a20,20,0,1,1-24.51294-19.46734,22.02362,22.02362,0,0,0,9.02588,0A20.02093,20.02093,0,0,1,327.2485,749.74592Zm-15.48706-21.53265a22.02316,22.02316,0,0,0-9.02588,0,19.97883,19.97883,0,0,1,0-38.93469,22.02362,22.02362,0,0,0,9.02588,0,19.97883,19.97883,0,0,1,0,38.93469Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#3f3d56"
			/>
			<path
				d="M648.2485,398.90779h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#f2f2f2"
			/>
			<path
				d="M648.2485,470.90779h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#f2f2f2"
			/>
			<path
				d="M648.2485,542.90779h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#f2f2f2"
			/>
			<path
				d="M648.2485,614.90779h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#f2f2f2"
			/>
			<path
				d="M648.2485,686.90779h-229a7,7,0,1,1,0-14h229a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#f2f2f2"
			/>
			<path
				d="M608.2485,398.90779h-190a7,7,0,1,1,0-14h190a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<path
				d="M549.2485,470.90779h-131a7,7,0,1,1,0-14h131a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<path
				d="M477.2485,542.90779h-59a7,7,0,1,1,0-14h59a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<path
				d="M626.2485,614.90779h-208a7,7,0,1,1,0-14h208a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<path
				d="M580.2485,686.90779h-162a7,7,0,1,1,0-14h162a7,7,0,0,1,0,14Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<rect
				x="603.997"
				y="257.5"
				width="2"
				height="14"
				fill={theme.secondaryText}
			/>
			<path
				d="M758.2485,399.90779a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,758.2485,399.90779Zm0-14a6,6,0,1,0,6,6A6.00655,6.00655,0,0,0,758.2485,385.90779Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<rect
				x="603.997"
				y="329.5"
				width="2"
				height="14"
				fill={theme.secondaryText}
			/>
			<path
				d="M758.2485,471.90779a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,758.2485,471.90779Zm0-14a6,6,0,1,0,6,6A6.00655,6.00655,0,0,0,758.2485,457.90779Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<rect
				x="603.997"
				y="401.5"
				width="2"
				height="14"
				fill={theme.secondaryText}
			/>
			<path
				d="M758.2485,543.90779a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,758.2485,543.90779Zm0-14a6,6,0,1,0,6,6A6.00655,6.00655,0,0,0,758.2485,529.90779Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<rect
				x="603.997"
				y="473.5"
				width="2"
				height="14"
				fill={theme.secondaryText}
			/>
			<path
				d="M758.2485,615.90779a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,758.2485,615.90779Zm0-14a6,6,0,1,0,6,6A6.00655,6.00655,0,0,0,758.2485,601.90779Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<rect
				x="603.997"
				y="545.5"
				width="2"
				height="14"
				fill={theme.secondaryText}
			/>
			<path
				d="M758.2485,687.90779a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,758.2485,687.90779Zm0-14a6,6,0,1,0,6,6A6.00655,6.00655,0,0,0,758.2485,673.90779Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.secondaryText}
			/>
			<circle cx="620.997" cy="264.5" r="4" fill={theme.secondaryText} />
			<circle cx="620.997" cy="480.5" r="4" fill={theme.secondaryText} />
			<circle cx="620.997" cy="552.5" r="4" fill={theme.secondaryText} />
			<circle cx="451.497" cy="192" r="7" fill="#3f3d56" />
			<circle cx="451.497" cy="7" r="7" fill="#3f3d56" />
			<rect x="450.49703" y="6.99993" width="2" height="185" fill="#3f3d56" />
			<path
				d="M993.86505,511.88678v24.77488s5.96432,39.91507,5.96432,74.78342S990.1947,727.52,990.1947,727.52s-19.26935,6.88191-20.64573-3.67035-5.04673-66.52513-5.04673-74.78342-16.05779-71.11306-16.05779-71.11306L938.351,647.6898s3.21156,82.58291,0,84.87688-18.81055,6.42312-20.64573,2.294-11.46985-92.67638-11.46985-92.67638-7.79949-115.61608-3.21156-122.498,8.71709-12.38744,8.71709-12.38744S977.34847,491.24106,993.86505,511.88678Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.dark}
			/>
			<path
				d="M987.90073,724.76719l1.15058,7.47874a73.664,73.664,0,0,1,.752,7.699c.17894,3.75694.80419,9.54528,2.94523,10.46287,3.21156,1.37638,24.05625,18.95588,9.37484,19.87347s-22.02612,2.50283-26.37484-.87347c-5.14118-3.99157.68238-2.18432-1.61159-2.18432s-5.04673,0-5.96432-3.67035,1.37638-10.09347,1.37638-10.09347V724.76719Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.dark}
			/>
			<path
				d="M919.39674,724.40779l-1.15058,7.47874a73.6637,73.6637,0,0,0-.752,7.699c-.17894,3.75694-.80419,9.54528-2.94523,10.46286-3.21156,1.37639-24.05625,18.95589-9.37484,19.87348s22.02612,2.50283,26.37484-.87348c5.14118-3.99156-.68238-2.18431,1.61159-2.18431s5.04673,0,5.96432-3.67035-1.37638-10.09347-1.37638-10.09347V724.40779Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.dark}
			/>
			<path
				d="M932.38666,312.7702s7.7995,19.26935,13.305,22.48091,2.75277,17.893,2.75277,17.893l-13.76382,19.26935H923.66957l-13.305-22.9397s-.91759-15.1402-3.67035-18.81055S932.38666,312.7702,932.38666,312.7702Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#ffb9b9"
			/>
			<path
				d="M932.38666,312.7702s7.7995,19.26935,13.305,22.48091,2.75277,17.893,2.75277,17.893l-13.76382,19.26935H923.66957l-13.305-22.9397s-.91759-15.1402-3.67035-18.81055S932.38666,312.7702,932.38666,312.7702Z"
				transform="translate(-137.2515 -127.40779)"
				opacity="0.1"
			/>
			<path
				d="M943.85651,352.22648l20.64573,4.58794,15.1402,152.3196s-8.25829,1.37638-16.51659,12.38744-18.35175,9.17588-23.39849,6.42311-25.23367-10.55226-25.69246-13.76382.91759-59.64321.91759-59.64321L902.10626,366.4491l6.42311-9.63468h11.46985l9.17588,7.7995Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.imageHighlight}
			/>
			<circle cx="775.40702" cy="185.36242" r="23.85729" fill="#ffb9b9" />
			<path
				d="M947.06807,344.427s44.96181,4.58793,49.091,14.22261-2.75276,52.30251-2.75276,52.30251,16.51658,37.16231,16.05779,45.8794,15.599,68.3603-1.83518,61.47839-11.92864-24.77487-20.64573-11.92864-12.38744,11.011-12.38744,11.011-8.71708,14.22262-11.46985,12.84623-4.58793-11.92864,1.37639-16.97537,5.04673-13.76382-6.42312-30.28041S934.68063,379.75412,941.56254,366.4491,947.06807,344.427,947.06807,344.427Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.jacketColor}
			/>
			<polygon
				points="856.614 393.196 848.814 400.537 839.179 394.114 843.309 384.479 856.614 393.196"
				fill="#ffb9b9"
			/>
			<path
				d="M914.0349,352.22648s-34.86834,12.84623-34.86834,26.61005,21.10452,73.86583,21.10452,73.86583,0,15.599-.91759,19.26935-15.35289,35.68266-2.75276,38.53869c7.865,1.78274,14.32706,6.466,14.9108,13.07554.6932,7.84884-5.31545,17.75542-4.81733,19.49883.91758,3.21156,6.42311,7.7995,5.96432,5.50553s3.67035-35.32713,10.09347-50.00854-2.75277-113.32211-4.58794-126.16834A141.98834,141.98834,0,0,0,914.0349,352.22648Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.jacketColor}
			/>
			<polygon
				points="758.432 392.278 766.69 412.007 772.884 399.39 765.772 383.561 758.432 392.278"
				fill="#ffb9b9"
			/>
			<path
				d="M939.53568,327.55077s7.53239,3.1124,12.12033,3.1124,23.39849,9.63467,16.97537,15.599-16.05779,7.3407-20.64573,16.05779-6.88191,10.09347-6.88191,10.09347L932.93558,361.441s11.37972-12.88488,10.92093-17.014S939.53568,327.55077,939.53568,327.55077Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.imageHighlight}
			/>
			<path
				d="M909.1255,338.58183s-5.64286,2.1748-7.01924,5.84516-10.09347,10.55226-6.42312,12.38743,19.72814,9.17588,22.9397,10.55226,9.19676-3.90494,9.19676-3.90494-8.04978-4.58274-8.04978-7.7943S909.1255,338.58183,909.1255,338.58183Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.imageHighlight}
			/>
			<path
				d="M890.17761,372.41342l-11.011,2.75276s-15.1402,67.90151-10.55226,84.87689,26.15125,67.9015,26.15125,67.9015l13.76382-16.05779s-6.00381-36.5151-9.425-38.90328-1.12724-7.43491-1.12724-8.81129,1.37638-.45879-1.83517-3.67035,11.92864-21.10452,7.79949-26.15126S890.17761,372.41342,890.17761,372.41342Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.jacketColor}
			/>
			<path
				d="M998.68239,385.03025,992.02988,360.026s17.893,12.84623,21.56331,31.65678,17.893,56.43166,8.71709,72.94825-25.23367,64.23115-30.7392,63.31356-18.81055-12.38743-19.26935-14.22261,23.85729-44.04422,20.18694-47.25578-2.75276-11.46985,0-13.305,5.96432-10.55226,3.67035-10.09347-9.17588-4.12915-7.7995-9.17588-6.88191-38.99749-6.88191-38.99749Z"
				transform="translate(-137.2515 -127.40779)"
				opacity="0.1"
			/>
			<path
				d="M989.73591,356.81442l6.42311,1.83518s17.893,12.84623,21.56332,31.65678,17.893,56.43166,8.71708,72.94824-25.23367,64.23116-30.73919,63.31357-18.81056-12.38744-19.26935-14.22261,23.85729-44.04422,20.18693-47.25578-2.75276-11.46985,0-13.305,5.96433-10.55226,3.67036-10.09346-9.17588-4.12915-7.7995-9.17588-6.88191-38.99749-6.88191-38.99749Z"
				transform="translate(-137.2515 -127.40779)"
				fill={theme.jacketColor}
			/>
			<path
				d="M931.17233,291.23524l4.47461-1.62714s-9.356-9.356-22.373-8.54236l3.66113-3.66107s-8.94922-3.25421-17.08484,5.28815c-4.27673,4.49054-9.225,9.76892-12.30969,15.715h-4.792l2,4-7,4,7.18481-.71851a20.18424,20.18424,0,0,0,.67957,10.35956l1.62707,4.47455s6.50855-13.017,6.50855-14.64411v4.06781s4.47461-3.661,4.47461-6.10168l2.44067,2.84747,1.22034-4.47461,15.0509,4.47461-2.44067-3.661,9.35595,1.22034-3.66113-4.47461s10.5763,5.28814,10.98316,9.76275,5.69482,10.1695,5.69482,10.1695l2.44067-4.06781S942.969,297.33692,931.17233,291.23524Z"
				transform="translate(-137.2515 -127.40779)"
				fill="#2f2e41"
			/>
			<ellipse cx="792.997" cy="182.5" rx="3.5" ry="5.5" fill="#ffb9b9" />
		</svg>
	);
};

export default SkillImg;
